import { Component, OnInit, inject, DOCUMENT } from '@angular/core';
import { ConfigService } from './_modules/shared/_services/config/config.service';
import { LanguageStore } from '@/_modules/shared/_stores/language.store';
import { style } from '@angular/animations';
import { RouterOutlet } from '@angular/router';
import { DialogsModule } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, DialogsModule],
})
export class AppComponent implements OnInit {
  private document = inject<Document>(DOCUMENT);
  private languageStore = inject(LanguageStore);
  private configService = inject(ConfigService);

  public textDirection = 'ltr';
  public language: string = 'en';
  title = 'LDQ';

  ngOnInit() {
    this.languageStore.state$.subscribe((c) => {
      this.textDirection = c.RTL ? 'rtl' : 'ltr';
      if (c.LID != null) {
        this.language = c.LID.toLowerCase();
        this.document.documentElement.lang = this.language;
      }
    });

    const brandColor = this.configService.getConfig().mareTest;

    const styleSheet = this.document.createElement('link');
    styleSheet.rel = 'style';
    styleSheet.href = style + '.css';
    this.document.getElementsByTagName('head')[0].appendChild(styleSheet);
  }
}
